/**
 * Impact Notes service — mirrors legacy Angular endpoints.
 * Route convention: backend accepts POST for both create AND update
 * (update distinguished by appending `/:id`). Matches http.service usage.
 */

import apiClient from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type {
  ImpactNote,
  ImpactNoteListParams,
  ImpactNoteListResponse,
  ImpactNoteSubmitPayload,
} from '../types'

const BASE_ENDPOINT = '/api/system_impact_notes'

export async function getImpactNotes(
  params: ImpactNoteListParams = {},
): Promise<ImpactNoteListResponse> {
  try {
    const response = await apiClient.get<ImpactNoteListResponse>(BASE_ENDPOINT, { params })
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load impact notes')
  }
}

export async function saveImpactNote(
  payload: ImpactNoteSubmitPayload,
  id?: number,
): Promise<ImpactNote> {
  try {
    const url = id ? `${BASE_ENDPOINT}/${id}` : BASE_ENDPOINT
    const response = await apiClient.post<ImpactNote>(url, payload)
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to save impact note')
  }
}

export async function deleteImpactNote(id: number): Promise<void> {
  try {
    await apiClient.delete(`${BASE_ENDPOINT}/${id}`)
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to delete impact note')
  }
}
